var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-progress',{attrs:{"value":_vm.amountSpent,"max":_vm.nextLevelAmount,"show-value":"","animated":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }